// extracted by mini-css-extract-plugin
export default {"component":"TopicComponent_component__vd3Pr"};